import React, { useState } from 'react';
import { Link } from "react-router-dom";
import styled from "styled-components";

import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

const Wrapper = styled.div`
  background-color: #254117;
  display: flex;
  align-items: top;
  justify-content: center;
  text-transform: uppercase;
  font-size: 13px;
  font-weight: bold;
  overflow: auto;
  white-space: nowrap;
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-end;
  }
`;

const Tabs = styled.div<{ isOpen: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: 600px) {
    flex-direction: column;
    width: 100%;
    display: ${({ isOpen }) => (isOpen ? "flex" : "none")};
  }
`;

const Tab = styled(Link)`
  color: white;
  text-decoration: none;
  text-align: center;
  padding: 10px;

  &:hover, &:focus, &:active {
    color: lightgreen;
  };
`;

const TabA = styled.a`
  color: white;
  text-decoration: none;
  text-align: center;
  padding: 10px;

  &:hover, &:focus, &:active {
    color: lightgreen;
  };
`;

const Menu = styled.div`
  transform: scale(1.25);
  margin: 15px;
  color: white;
  @media (min-width: 600px) {
    display: none !important;
  }
`;

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Wrapper>
      <Menu onClick={ toggleMenu }>
      { isOpen ? <CloseIcon  /> : <MenuIcon /> }
      </Menu>
      <Tabs isOpen={ isOpen }>
        <Tab to="/home">Strona główna</Tab>
        <Tab to="/about-me">O mnie</Tab>
        <Tab to="/projects">Projekty</Tab>
        <Tab to="/media">Media</Tab>
        <Tab to="/contact">Kontakt</Tab>
      </Tabs>
    </Wrapper>
  );
};